import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  container: {
    padding: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 4),
    fontSize: '1.1rem',
  },
  info: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.info.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.info.main}`,
  },
  success: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.success.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.success.main}`,
    marginTop: theme.spacing(2),
  },
}))
